import { Routes } from '@angular/router';
import { authGuard, unauthGuard } from './guards/auth-oidc.guard';
import { roleGuard } from './guards/role.guard';
import { documentResolver } from './store/documents/document.resolver';
import { documentTypeResolver } from './store/document-type/document-type.resolver';
import { dataTypeResolver } from './store/data-type/data-type.resolver';
import { extractionRuleResolver } from './store/extraction-rule/extraction-rule.resolver';
import { Role } from './services/model';

export const routes: Routes = [
  {
    path: 'system-health',
    loadComponent: () => import('./pages/system-health.component').then((c) => c.SystemHealthComponent),
    title: 'System Health',
    canActivate: [authGuard],
  },
  {
    path: 'documents',
    loadComponent: () =>
      import('./components/documents/documents-list/documents.component').then((c) => c.DocumentsComponent),
    title: 'Dokumente',
    resolve: {
      documents: documentResolver,
      documentTypes: documentTypeResolver,
    },
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.Admin, Role.Manager, Role.User, Role.Viewer] },
  },
  {
    path: 'document-types',
    loadComponent: () =>
      import('./components/document-type/document-type-list/document-type-list.component').then(
        (c) => c.DocumentTypeListComponent
      ),
    title: 'Dokumententypen',
    resolve: {
      documentTypes: documentTypeResolver,
    },
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.Admin, Role.Manager, Role.User, Role.Viewer] },
  },
  {
    path: 'data-types',
    loadComponent: () =>
      import('./components/data-type/data-type-list/data-type-list.component').then((c) => c.DataTypeListComponent),
    title: 'Datentypen',
    resolve: {
      dataTypes: dataTypeResolver,
    },
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.Admin, Role.Manager, Role.User, Role.Viewer] },
  },
  {
    path: 'extraction-rules',
    loadComponent: () =>
      import('./components/extraction-rule/extraction-rule-list/extraction-rule-list.component').then(
        (c) => c.ExtractionRuleListComponent
      ),
    title: 'Extraktionsregeln',
    resolve: {
      extractionRules: extractionRuleResolver,
    },
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.Admin, Role.Manager, Role.User, Role.Viewer] },
  },
  {
    path: 'extraction-rules/:id',
    loadComponent: () =>
      import('./components/extraction-rule-details/extraction-rule-details.component').then(
        (c) => c.ExtractionRuleDetailsComponent
      ),
    title: 'Extraktionsregel Details',
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.Admin, Role.Manager, Role.User, Role.Viewer] },
  },
  {
    path: 'documents/:id',
    loadComponent: () =>
      import('./components/document-detail/document-detail.component').then((m) => m.DocumentDetailComponent),
    title: 'Dokument Details',
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.Admin, Role.Manager, Role.User, Role.Viewer] },
  },
  {
    path: 'team-management',
    loadComponent: () =>
      import('./pages/team-management/team-management.component').then((c) => c.TeamManagementComponent),
    title: 'Team Management',
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.Admin] },
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./pages/unauthorized/unauthorized.component').then((c) => c.UnauthorizedComponent),
    title: 'Zugriff verweigert',
    // NO guards - must be accessible to break redirect loops
  },
  {
    path: '',
    redirectTo: 'address',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then((c) => c.LoginComponent),
    title: 'Anmelden',
    canActivate: [unauthGuard],
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./components/auth-callback/auth-callback.component').then((c) => c.AuthCallbackComponent),
    title: 'Authentifizierung...',
  },
  {
    path: 'auth/register',
    loadComponent: () => import('./auth/register/register.component').then((c) => c.RegisterComponent),
    title: 'Registrieren',
  },
  {
    path: 'auth/forgot-password',
    loadComponent: () =>
      import('./auth/forgot-password/forgot-password.component').then((c) => c.ForgotPasswordComponent),
    title: 'Passwort vergessen',
  },
  {
    path: 'address',
    loadComponent: () => import('./address-form/address-form.component').then((c) => c.AddressFormComponent),
    title: 'Address',
    // No guards - safe landing page after authentication
  },
  {
    path: 'table',
    loadComponent: () => import('./table/table.component').then((c) => c.TableComponent),
    title: 'Table',
  },
  {
    path: 'tree',
    loadComponent: () => import('./tree/tree.component').then((c) => c.TreeComponent),
    title: 'Tree',
  },
  {
    path: 'drag-drop',
    loadComponent: () => import('./components/drag-drop/drag-drop.component').then((c) => c.DragDropComponent),
    title: 'Drag-Drop',
  },
  {
    path: '**',
    redirectTo: 'address',
  },
];
